/* ZOD */
import { ZodString } from './types/string';
import { ZodNumber } from './types/number';
import { ZodBigInt } from './types/bigint';
import { ZodBoolean } from './types/boolean';
import { ZodDate } from './types/date';
import { ZodUndefined } from './types/undefined';
import { ZodNull } from './types/null';
import { ZodAny } from './types/any';
import { ZodUnknown } from './types/unknown';
import { ZodVoid } from './types/void';
import { ZodArray } from './types/array';
import { ZodObject } from './types/object';
import { ZodUnion } from './types/union';
import { ZodIntersection } from './types/intersection';
import { ZodTuple } from './types/tuple';
import { ZodRecord } from './types/record';
import { ZodFunction } from './types/function';
import { ZodLazy } from './types/lazy';
import { ZodLiteral } from './types/literal';
import { ZodEnum } from './types/enum';
import { ZodNativeEnum } from './types/nativeEnum';
import { ZodPromise } from './types/promise';
import { ZodType, ZodTypes } from './types/base';
// import { ZodError, ZodErrorCode, ZodInvalidTypeError,
// ZodNonEmptyArrayIsEmptyError,
// ZodUnrecognizedKeysError,
// ZodInvalidUnionError,
// ZodInvalidLiteralValueError,
// ZodInvalidEnumValueError,
// ZodInvalidArgumentsError,
// ZodInvalidReturnTypeError,
// ZodInvalidDateError,
// ZodInvalidStringError,
// ZodTooSmallError,
// ZodTooBigError,
// ZodCustomError } from './ZodError';
import { ZodParsedType } from './parser';
import { ZodCodeGenerator } from './codegen';
export { ZodTypes };
const stringType = ZodString.create;
const numberType = ZodNumber.create;
const bigIntType = ZodBigInt.create;
const booleanType = ZodBoolean.create;
const dateType = ZodDate.create;
const undefinedType = ZodUndefined.create;
const nullType = ZodNull.create;
const anyType = ZodAny.create;
const unknownType = ZodUnknown.create;
const voidType = ZodVoid.create;
const arrayType = ZodArray.create;
const objectType = ZodObject.create;
const unionType = ZodUnion.create;
const intersectionType = ZodIntersection.create;
const tupleType = ZodTuple.create;
const recordType = ZodRecord.create;
const functionType = ZodFunction.create;
const lazyType = ZodLazy.create;
const literalType = ZodLiteral.create;
const enumType = ZodEnum.create;
const nativeEnumType = ZodNativeEnum.create;
const promiseType = ZodPromise.create;
const ostring = () => stringType().optional();
const onumber = () => numberType().optional();
const oboolean = () => booleanType().optional();
const codegen = ZodCodeGenerator.create;
export const custom = (check, params) => anyType().refine(check, params);
const instanceOfType = (cls, params = { message: `Input not instance of ${cls.name}` }) => custom(data => data instanceof cls, params);
export { stringType as string, numberType as number, bigIntType as bigint, booleanType as boolean, dateType as date, undefinedType as undefined, nullType as null, anyType as any, unknownType as unknown, voidType as void, arrayType as array, objectType as object, unionType as union, intersectionType as intersection, tupleType as tuple, recordType as record, functionType as function, lazyType as lazy, literalType as literal, enumType as enum, nativeEnumType as nativeEnum, promiseType as promise, instanceOfType as instanceof, ostring, onumber, oboolean, codegen, };
export const late = {
    object: ZodObject.lazycreate,
};
export { ZodString, ZodNumber, ZodBigInt, ZodBoolean, ZodDate, ZodUndefined, ZodNull, ZodAny, ZodUnknown, ZodVoid, ZodArray, ZodObject, ZodUnion, ZodIntersection, ZodTuple, ZodRecord, ZodFunction, ZodLazy, ZodLiteral, ZodEnum, ZodNativeEnum, ZodPromise, ZodType, ZodType as Schema, ZodType as ZodSchema, ZodParsedType, ZodCodeGenerator, };
export * from './ZodError';
